import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-card-referente',
  templateUrl: './card-referente.component.html',
  styleUrls: ['./card-referente.component.scss']
})
export class CardReferenteComponent implements OnInit {

  constructor(private router: Router,) { }

  ngOnInit(): void {
  }

  rutas(params: string) {
    this.router.navigate([params]);
  }
}
